import { RouteCode } from './../../classes/route-code';
export type LogCategory = "missingTranslation" | "cityMapResolver" | "homePageComponent" | "listingsService" | "httpRequests";


/**
 * This service is an abstraction of sending response info
 */
export abstract class ResponseService {
    
    abstract setResponseCode(code: string, redirectUrl?: string) : void;

    abstract setRouteCode(code: RouteCode);
}